$(".copy-link").on("click", function() {
  navigator.clipboard.writeText($(this).attr('data-link-url'));
});
